import "./App.css";
import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Headernavabar from "./AllComponents/Headernavbar";
import Footer from "./AllComponents/Footer";
import Webfooter from "./AllComponents/Webfooter";
import ScrollToTop from "./AllComponents/scrolltoTop";
import Home from "./AllComponents/Home";
import AboutUs from "./AllComponents/AboutUs";
import Contact from "./AllComponents/Contact";
import Productcard from "./AllComponents/Productcard";
import Productdetails from "./AllComponents/Productdetails";
import Product from "./AllComponents/Products";
import AllProductsPage from "./AllComponents/Allproducts"; 
import Cart from "./AllComponents/Cart";
import Blog from "./AllComponents/Blog";
import BlogDetails from "./AllComponents/BlogDetails";
import ContactForm from "./AllComponents/ContactForm";
import AuthLogin from "./AllComponents/AuthLogin";
import Profile from "./AllComponents/Profile";
import EditProfile from "./AllComponents/editProfile";
import CheckOutPage from "./AllComponents/CheckOutPage";
import OurCollection from "./AllComponents/OurCollection";
import Settings from "./AllComponents/Setting";
import Help from "./AllComponents/Help";
import PaymentSummary from "./AllComponents/Paymentcard";
import Dashboard from "./Dashboard";
import CheckoutHeader from "./AllComponents/CheckoutHeader";

import Swal from "sweetalert2";

function App() {
  const location = useLocation();
  const path = location.pathname.toLowerCase().trim();

  // useEffect(() => {
  //   // Disable right-click
  //   const handleContextMenu = (e) => {
  //     e.preventDefault();
  //     Swal.fire({
  //       icon: "warning",
  //       title: "Action Blocked!",
  //       text: "Right-click is disabled on this website."
  //     });
  //   };
  //   document.addEventListener("contextmenu", handleContextMenu);

  //   // Disable text selection
  //   document.body.style.userSelect = "none";
  //   document.body.style.webkitUserSelect = "none";
  //   document.body.style.msUserSelect = "none";
  //   document.body.style.mozUserSelect = "none";

  //   // Disable copy, cut, drag
  //   const handleCopyCut = (e) => {
  //     e.preventDefault();
  //     Swal.fire({
  //       icon: "warning",
  //       title: "Action Blocked!",
  //       text: "Copy & Cut are disabled on this website."
  //     });
  //   };

  //   // const handleDrag = (e) => e.preventDefault();

  //   // document.addEventListener("copy", handleCopyCut);
  //   // document.addEventListener("cut", handleCopyCut);
  //   // document.addEventListener("dragstart", handleDrag);

  //   // Disable keyboard shortcuts (Ctrl+C, Ctrl+X, Ctrl+S, Ctrl+U)
  //   // const handleKeyDown = (e) => {
  //   //   if (e.ctrlKey && ["c", "x", "s", "u"].includes(e.key.toLowerCase())) {
  //   //     e.preventDefault();
  //   //     Swal.fire({
  //   //       icon: "error",
  //   //       title: "Shortcut Disabled!",
  //   //       text: "Keyboard shortcuts are disabled on this website."
  //   //     });
  //   //   }
  //   // };
  //   // document.addEventListener("keydown", handleKeyDown);

  //   // Cleanup on unmount
  //   return () => {
  //     document.removeEventListener("contextmenu", handleContextMenu);
  //     document.removeEventListener("copy", handleCopyCut);
  //     document.removeEventListener("cut", handleCopyCut);
  //     document.removeEventListener("dragstart", handleDrag);
  //     document.removeEventListener("keydown", handleKeyDown);
  //   };
  // }, []);

  const isCheckoutFlow =
    path === "/cart" ||
    path.startsWith("/checkout") ||
    path.startsWith("/checkout/") ||
    path.startsWith("/paymentsummary");

  return (
    <>
      {isCheckoutFlow ? <CheckoutHeader /> : <Headernavabar />}

      <ScrollToTop />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/Productcard" element={<Productcard />} />
        <Route path="/productdetails/:id" element={<Productdetails />} />
        <Route path="/Product" element={<Product />} />
        <Route path="/allproducts/:categoryid" element={<AllProductsPage />} /> 
        <Route path="/Cart" element={<Cart />} />
        <Route path="/Blog" element={<Blog />} />
        <Route path="/BlogDetails/:id" element={<BlogDetails />} />
        <Route path="/ContactForm" element={<ContactForm />} />
        <Route path="/AuthLogin" element={<AuthLogin />} />
        <Route path="/Profile" element={<Profile />} />
        <Route path="/editProfile" element={<EditProfile />} />
        <Route path="/OurCollection/:id" element={<OurCollection />} />
        <Route path="/CheckOut/:status" element={<CheckOutPage />} />
        <Route path="/PaymentSummary" element={<PaymentSummary />} />
        <Route path="/Dashboard" element={<Dashboard />} />
        <Route path="/Setting" element={<Settings />} />
        <Route path="/Help" element={<Help />} />
      </Routes>

      {!isCheckoutFlow && (
        <>
          <Webfooter />
          <Footer />
        </>
      )}
    </>
  );
}

export default App;
